import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import { EMPTY, Observable, of, throwError } from 'rxjs';
import { catchError, expand, filter, map, reduce, tap } from 'rxjs/operators';
import {environment} from '../../../environments/environment';
import { FlavorResponse, Location, Shift } from '../models/flavor.model';

@Injectable({
    providedIn: 'root',
})
export class OrderWithFlavorService {

    constructor(
        private http: HttpClient,
    ){}

    public getLocations(deployment:string): Observable<Location[]> {
        return this.http.get(environment.apiUrl + `flavor/locations/${deployment}`).pipe(
            map((response: FlavorResponse<Location>) => response.results), 
            catchError(this.handleError)
        );
    }

    public getShifts(deployment: string): Observable<Shift[]> {
        const now = new Date();
        const localDateString = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;

        const lteDate = new Date(now);
        lteDate.setFullYear(lteDate.getFullYear() + 1);

        const lteDateString = `${lteDate.getFullYear()}-${String(lteDate.getMonth() + 1).padStart(2, '0')}-${String(lteDate.getDate()).padStart(2, '0')}`;

        const limit = 20;
        let offset = 0;

        const buildUrl = (offset: number) => 
            `${environment.apiUrl}flavor/shifts/${deployment}?dayGte=${localDateString}&dayLte=${lteDateString}&limit=${limit}&offset=${offset}`;

        return this.paginatedShiftRequest(buildUrl, limit, offset).pipe(
            reduce((all: Shift[], resp) => all.concat(resp.results), []),
            catchError(this.handleError)
        );
    }

    private paginatedShiftRequest(
        buildUrl: (offset: number) => string,
        limit: number,
        offset: number
    ): Observable<FlavorResponse<Shift>> {
        return this.http.get<FlavorResponse<Shift>>(buildUrl(offset)).pipe(
            expand((response, i) => {
                const nextOffset = (i + 1) * limit;
    
                if (response.results.length < limit || nextOffset > 500) {
                    return EMPTY;
                }
    
                return this.http.get<FlavorResponse<Shift>>(buildUrl(nextOffset));
            })
        );
    }    
    

    private handleError(error: any) {
        console.error(error);
        return throwError(() => error);
      }
}